import { useState } from 'react'
import { Button } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { CreateSubscriberModal } from '@/features/subscriber/CreateSubscriberModal'
import { SubscriberTable } from '@/features/subscriber/SubscriberTable'
import { Can } from '@/shared/auth/Can'
import { PageHeader } from '@/shared/ui/PageHeader'

export function SubscribersPage() {
  const { t } = useTranslation()
  const [createOpen, setCreateOpen] = useState(false)

  return (
    <>
      <PageHeader
        title={t('nav.subscribers')}
        extra={
          // Yaratish huquqi yo'q bo'lsa tugma CHIZILMAYDI — bosib
          // bo'lmaydigan tugma ko'rsatish foydalanuvchini adashtiradi
          <Can permission="subscriber.create">
            <Button type="primary" icon={<PlusOutlined />} onClick={() => setCreateOpen(true)}>
              {t('operation.newSubscriber')}
            </Button>
          </Can>
        }
      />
      <SubscriberTable />
      <CreateSubscriberModal open={createOpen} onClose={() => setCreateOpen(false)} />
    </>
  )
}
